// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--LXHx1"};